import React, { Component } from 'react';

//components
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

//images
import BedImage from '../../assets/bed.png';
import BathImage from '../../assets/bath.png';
import AreaImage from '../../assets/area.png';


//styling
import { withStyles } from '@material-ui/core/styles';
import './Cards.css'



const style = (theme) => ({
    root: {
      minWidth: "calc(100% - 20px)",
      maxWidth: "calc(100% - 20px)",
      marginTop: "20px",
      marginBottom: "20px",
      minHeight: 620,
      maxHeight: 620,
      position:'relative',
      // borderBottom: '5px solid #D13239',

    },
    media: {
      height: 300,
      //   backgrondSize: 'auto 250px',
    },
    CardActionArea: {
      flex: 1,
      width: "100%",
    },
    CardContent:
    {
      textAlign:'left',
      padding:'25px',
      paddingTop:'35px'
    },
    SearchResults: {
      marginTop: "30px",
      marginBottom:'50px',
      fontSize: "21px",
      color: "#454545",
      position:"relative",
      left:'0px',
      textAlign:"left"
    },
    bold:
    {
        fontWeight:'bold',
        color:'black'
    }
    
  });

class Cards extends Component {
    constructor(props) {
      super(props);
      this.state = {  }
    }

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    handleRedirect = (url) =>
    {
      window.location.href=url;
    }

    render() { 

        const {classes , loading, list} = this.props;

        return (
        <div className="all-cards-wrapper">

          {
            loading?
            [1,2,3].map((a,id)=>(
              <div className="main-card-wrapper" style={{ textAlign: "center" }}>
               
                <Card className={classes.root}>
                  <CardActionArea className={classes.CardActionArea}>
                    <Skeleton animation="wave" variant="rect" className={classes.media} />
                    <CardContent className={classes.CardContent}>
                      <div className="card-address-bar">
                        <Skeleton animation="wave" width="80%" style={{ marginBottom: 1 }} />
                        <Skeleton animation="wave" width="80%" style={{ marginBottom: 6 }} />
                      </div>

                      <div className="card-price-bar">
                        {/* ${this.numberWithCommas(Math.round(listItem.List_Price))} */}
                        <Skeleton animation="wave" width="10%" />
                      </div>

                      <div className="card-description-bar">
                        <div className="ellipsis_2">
                          {/* {listItem.Property_Description} */}
                          <Skeleton animation="wave" width="90%" style={{ marginBottom: 1 }} />
                          <Skeleton animation="wave" width="90%" style={{ marginBottom: 6 }} />
                        </div>
                      </div>
                    </CardContent>
                  </CardActionArea>
                  <CardActions style={{ position: "absolute",bottom:'35px', paddingBottom: "0px", width: "100%" }}>
                    <span className="plp-page-details-button-text">
                      {"View Listing >"}
                    </span>
                  </CardActions>
                </Card>
              </div>)
            )

    
            : list.map((listItem, id) => (
          <div key={id} className="main-card-wrapper" style={{ textAlign: "center" }}>
            
            <Card className={classes.root}>
              <CardActionArea className={classes.CardActionArea} onClick={() => this.handleRedirect(listItem.redirection)}>
                <CardMedia className={classes.media} image={listItem.imageUrl}  />
                <CardContent className={classes.CardContent}>

                  <div className="card-address-bar"> 
                    <div className="ellipsis_1">
                      {/* {listItem.Street_Num + " " + listItem.Street_Name + " " + listItem.Street_Suffix} */}
                      {listItem.price}
                    </div>
                    {/* <div className="ellipsis_1">
                        {listItem.City + " " +listItem.State + " " +listItem.Zip_Code}
                    </div> */}
                  </div>

                  <div className="ellipsis_1 card-sub-title-bar">
                    {/* ${this.numberWithCommas(Math.round(listItem.List_Price))} */}
                    {listItem.subTitle}
                  </div>

                  <div className="card-description-bar">
                    <div className="ellipsis_2 keyword">
                      {listItem.keyword}
                    </div>
                    <div className="additionalData">
                      <div className="additional-data-block additional-data-block1">
                        <div className="additional-data-block-up">
                          <div className="additional-data-block-text"> {listItem.additionData.beds} </div>
                          <div className="additional-data-block-image-wrapper"> <img className="additional-data-block-image" src={BedImage}/> </div>
                        </div>
                        <div className="additional-data-block-down">
                          BEDS
                        </div>
                      </div>
                      <div className="additional-data-block additional-data-block1">
                        <div className="additional-data-block-up">
                          <div className="additional-data-block-text"> {listItem.additionData.baths}  </div>
                          <div className="additional-data-block-image-wrapper"> <img className="additional-data-block-image" src={BathImage}/> </div>
                        </div>
                        <div className="additional-data-block-down">
                          BATHS
                        </div>
                      </div>
                      <div className="additional-data-block additional-data-block1">
                        <div className="additional-data-block-up">
                          <div className="additional-data-block-text"> {listItem.additionData.sqft} </div>
                          <div className="additional-data-block-image-wrapper"> <img className="additional-data-block-image" src={AreaImage}/> </div>
                        </div>
                        <div className="additional-data-block-down">
                          SQFT
                        </div>
                      </div>
                      {listItem.Property_Description}
                    </div>
                  </div>
                </CardContent>
              </CardActionArea>
              <CardActions style={{ position: "absolute",bottom:'35px', paddingBottom: "0px", width: "100%" }}>
               
                <span className="plp-page-details-button-text" onClick={() => this.handleRedirect(listItem.redirection)} >
                  {"View Listing >"}
                </span>
              </CardActions>
            </Card>
          </div>
        ))}
      </div> );
    }
}
 

export default withStyles(style)(Cards);